// =============================================================================
// FontsSettingsTab
// =============================================================================
// Hosts the managed font catalog (SYSTEM uploads + read-only view of STORE
// uploads). Per-store text-tool settings live on the tenant detail page.
// =============================================================================

import { FontsPanel } from './FontsPanel';
import { StoreTextSettingsPanel } from './StoreTextSettingsPanel';

export function FontsSettingsTab() {
  return (
    <div className="space-y-6">
      <FontsPanel />
      <StoreTextSettingsPanel />
    </div>
  );
}
